$(document).ready(function(){
  $('.product-selector_block').click(function(){
    var currentMode = $('.product-selector_outer.active_block').attr('data')
    var currentIndex = $(this).attr('data-index');

    $('.product-selector_block').removeClass('active');
    $(this).addClass('active');
    $('.product-selector_block[data-index="'+currentIndex+'"]').addClass('active');

    var indexOpt = $(this).attr("data-index");
    $(".product_atc-refills").addClass("hided");
    $('.product_atc-refills[data="' + indexOpt + '"]').removeClass("hided");

    $('.cta-note.changeble').addClass('hided');
    $('.cta-note.changeble[data-id="'+indexOpt+'"]').removeClass('hided');
    
  });

  $('.pp_var_autoship').click(function(){
    $(this).toggleClass('disabled');
    if ($('.pp_var_autoship').hasClass('disabled')){
      $('.product-selector_outer[data="sub"]').removeClass('active_block');
      $('.product-selector_outer[data="otp"]').addClass('active_block');
    }
    else{
      $('.product-selector_outer[data="sub"]').addClass('active_block');
      $('.product-selector_outer[data="otp"]').removeClass('active_block');
    }
  });

  $('.product-selector_atc_coc_sel').click(function(){
    var newUrl = $('.product-selector_outer.active_block').find('.product-selector_block.active').attr('data-coc-url');
    window.location.href = newUrl;
  });


  $('.product-selector_atc_coc').click(function(){
    var newUrl = $(this).attr('data-coc-url');
    window.location.href = newUrl;
  });

  $('.product-selector_atc').click(function(){

    if ($(this).attr("data-mode-champs") == "true") {

      var baseUrl = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-coc-url");

      // capture utm params from current page
      var urlParams = new URLSearchParams(window.location.search);

      var utmParams = [];

      urlParams.forEach(function(value, key) {
        if (key.startsWith('utm')) {
          utmParams.push(key + '=' + encodeURIComponent(value));
        }
      });

      var finalUrl = baseUrl;

      if (utmParams.length) {
        finalUrl += (baseUrl.includes('?') ? '&' : '?') + utmParams.join('&');
      }

      window.location.href = finalUrl;

    } else {

      var currentId = $('.product-selector_outer.active_block')
        .find('.product-selector_block.active')
        .attr('data-id');

      var mode = $('.product-selector_outer.active_block').attr('data');

      var currentSellingPlan = $('.product-selector_outer.active_block')
        .find('.product-selector_block.active')
        .attr('data-selling-plan');

      var data;

      if (mode == 'sub'){
        data = {
          id: currentId,
          quantity: 1,
          selling_plan: currentSellingPlan
        };
      }
      else{
        data = {
          id: currentId,
          quantity: 1
        };
      }

      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        error: function() {
          alert('Error adding item to the cart.');
        }
      });

    }

  });
});